import { render, staticRenderFns } from "./SellerAccountSection.vue?vue&type=template&id=154648a5"
import script from "./SellerAccountSection.vue?vue&type=script&lang=js"
export * from "./SellerAccountSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports